<template>
    <div v-if="loading?.general" class="loader-units-vertical">
        <ui-load-indicator :h="70" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
    </div>

    <div v-else class="container-units-list">
        <section class="container-units-list-content">
            <div class="data-units">
                <span class="resume">Resumo:</span>

                <div
                    v-for="(data, i) in visualization.summary"
                    :key="i"
                    class="data"
                >
                    <span class="text">{{ data.label }}: </span>
                    <span class="value">{{ data.value_label }}</span>
                </div>
            </div>

            <div class="enterprise-vertical">
                <ui-enterprise-vertical :data="visualization" @load="loadData" />
            </div>
        </section>
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

    import uiEnterpriseVertical from '@/components/ui/enterprise-vertical'

    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'ui-units-list',

        components: {
            uiEnterpriseVertical,
            uiLoadIndicator
        },

        props: {
            id: {
                type: [String, Number],
                required: true
            }
        },

        data() {
            return {
                unsubscribe: null
            }
        },

        computed: {
            ...mapGetters('product', {
                product: 'getProduct',
                visualization: 'getVisualization',
                loading: 'getLoading'
            })
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe(mutation => {
                if (mutation.type === 'product/SET_PRODUCT' &&
                    mutation?.payload?.id &&
                    mutation.payload?.availability?.type === 'horizontal') {
                    this.$router.push({
                        name: 'products.unitsHorizontal',
                        params: { id: mutation.payload.id },
                        replace: true
                    })
                }
            })
        },

        beforeDestroy() {
			this.unsubscribe()
        },

        mounted() {
            this.loadData()
        },

        methods: {
            ...mapActions('product', [
                'loadVisualization'
            ]),
            /**
             * Chama a action do módulo vuex de Produto para carregar os dados da visualização
             */
            loadData() {
                this.loadVisualization(this.id)
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>